import React from 'react';
import styled from 'styled-components';
import { SectionName, SectionTitle } from '../common/styles';

const Container = styled.div`
  margin: ${props => (props.theme.isMobile ? '67px 0 19px 19px' : '0 auto')};
  padding-bottom: 6px;
  max-width: 1230px;
  width: 85vw;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const Timestamp = styled(SectionName)`
  font-size: 12px;
`;

export const Title = styled(SectionTitle)`
  margin: 6px 0 0 0;
  line-height: 40px;
  height: 46px;
  max-width: 795px;
  border-bottom: 1px dashed ${props => props.theme.primaryColor};
  font-size: ${props => (props.theme.isMobile ? 25 : 40)}px;
`;

export const Section = styled.div`
  max-width: 1180px;
  width: 82vw;
  font-size: 16px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: start;
  line-height: 25px;
`;

export const InnerSection = styled(Section)`
  max-width: 1120px;
`;

export const Paragraph = styled.p`
  position: relative;
  max-width: 449px;
  margin-top: 24px;
  color: ${props => props.theme.bodyColor};
  font-size: 20px;
  line-height: 25px;
  text-align: left;
`;

export const Intro = styled(Paragraph)`
  max-width: 1180px;
  font-size: 16px;
  margin-top: 44px;
`;

export const Headline = styled(Paragraph)`
  max-width: 1180px;
  width: 82vw;
  font-size: 20px;
  font-weight: ${props => props.theme.fontWeightBold};
  margin-top: 33px;
`;

export const SubHeadline = styled(Paragraph)`
  max-width: 1180px;
  width: 82vw;
  font-size: 18px;
`;

const Span10 = styled.span`
  margin-right: 10px;
`;

export default function Content() {
  return (
    <Container>
      {/* eslint-disable max-len */}
      {/* eslint react/jsx-one-expression-per-line: 0 */}
      <Timestamp>Updated 26 March 2018</Timestamp>
      <Title>Terms &amp; Conditions</Title>
      <Intro>Thank you for visiting www.livewiremarkets.com. We&apos;re glad you&apos;re here and look forward to giving you all the features and information on offer through the site. But in doing so, there are some rules you must agree to.</Intro>
      <Headline>1. Background</Headline>
      <Section>
        <Span10>1.1</Span10>
        <span>These Terms of Use <strong>(Terms)</strong> govern your use of the website located at http://www.livewiremarkets.com <strong>(Website)</strong> and form a binding contractual agreement between you, the user of the Website and Livewire Markets Pty Ltd ACN 156 343 501 <strong>(Livewire)</strong>.</span>
      </Section>
      <Section>
        <Span10>1.2</Span10>
        <span>These Terms are important and you should read them carefully and contact Livewire with any questions before you use the Website. </span>
      </Section>
      <Section>
        <Span10>1.3</Span10>
        <span>By using the Website you acknowledge and agree that you have read and understand these Terms and you agree to be bound by them.</span>
      </Section>
      <Section>
        <Span10>1.4</Span10>
        <span>Livewire may provide any notice required under these terms by publishing the notice on the Website <strong>(Notice)</strong>. <strong>Livewire may amend or vary these Terms at its sole discretion by giving Notice. The varied Terms are to take effect immediately upon Notice being given.</strong>
          &nbsp;Your continued use of the Website after any variation of these Terms will be deemed to constitute your acceptance of the varied Terms. If you do not accept the varied Terms, please discontinue your use of the Website and/or terminate your Membership.
        </span>
      </Section>
      <Headline>2. Definitions</Headline>
      <Section>
        <Span10>2.1</Span10>
        <span><strong>Confidential Information</strong> means any information of Livewire, or of another User which is designated as confidential or which is of a confidential or sensitive nature,
        &nbsp;which is marked or denoted as confidential or which a reasonable person to whom that information is disclosed or to whose knowledge the information comes would consider confidential.
        </span>
      </Section>
      <Section>
        <Span10>2.2</Span10>
        <span><strong>Content</strong> means anything that is uploaded, posted or otherwise transmitted through the Website, and when it is introduced to the Services by you, it is your Content.</span>
      </Section>
      <Section>
        <Span10>2.3</Span10>
        <span><strong>Intellectual Property</strong> means all intellectual property rights (including all registered and unregistered copyright, designs, trade marks and patents) of any nature in any technology, trade secrets, User lists, User details (including User emails, telephone numbers and addresses)
        &nbsp;and User-related information, software, program, inventions, designs, works and subject matter belonging to Livewire.
        </span>
      </Section>
      <Section>
        <Span10>2.4</Span10>
        <span><strong>Membership</strong> means an application to Livewire, through the Website, for a User name, account and password.</span>
      </Section>
      <Section>
        <Span10>2.5</Span10>
        <span><strong>Membership Data</strong> means any information provided by you to Livewire in any registration form on the Website or otherwise.</span>
      </Section>
      <Section>
        <Span10>2.6</Span10>
        <span><strong>Services</strong> means the publication of content and information relating to financial markets and other news provided by Livewire to users from time to time through multiple channels, including the Website, email, video and other social media platforms.</span>
      </Section>
      <Section>
        <Span10>2.7</Span10>
        <span><strong>Third Party</strong> means an entity other than LiveWire or its related bodies corporate.</span>
      </Section>
      <Section>
        <Span10>2.8</Span10>
        <span><strong>You</strong> means the user or any other party currently accessing the Services.</span>
      </Section>
      <Headline>3. Use of Website</Headline>
      <Section>
        <Span10>3.1</Span10>
        <span>Livewire grants you a non-exclusive, non-transferable licence to use the Website and Services subject to the terms and conditions set out in these Terms.</span>
      </Section>
      <Section>
        <Span10>3.2</Span10>
        <span>The Website contains links to other websites and may from time to time contain Content added by a Third Party. Livewire does not endorse, sponsor or approve any such user generated content or any content available on any linked website.</span>
      </Section>
      <Section>
        <Span10>3.3</Span10>
        <span>Livewire expressly disclaims all liability for any Content transmitted or posted on the Website or Services, or otherwise transmitted to any User by any other means, or by any person, including your reliance on such Content.</span>
      </Section>
      <Section><Span10>3.4</Span10>
        <span>You acknowledge and agree that:
          <div>
            <InnerSection><Span10>a)</Span10> Livewire retains editorial control over the Website and Services and may alter, amend or cease the operation of the Website at any time in its sole discretion; and</InnerSection>
            <InnerSection><Span10>b)</Span10> the Website will not operate on a continuous basis and may be unavailable from time to time (including for maintenance purposes).</InnerSection>
          </div>
        </span>
      </Section>
      <Section>
        <Span10>3.5</Span10>
        <span>You agree and understand that you assume all risks when using the Website and Services, including without limitation any and all of the risks associated with any online or offline interactions with other Users and all risk for any damage to your computer system or loss of data.</span>
      </Section>
      <Headline>4. Financial Content, not Advice</Headline>
      <Section>
        <Span10>4.1</Span10>
        <span>You acknowledge and agree that:
          <div>
            <InnerSection>
              <Span10>a)</Span10>
              Livewire gives you access to research and opinions about financial markets and financial news, but Livewire does not itself provide any opinions, advice or recommendations; like other financial media outlets,
              &nbsp;Livewire’s primary purpose is to publish financial markets content, not to provide financial product advice; and accordingly, Livewire does not hold an Australian Financial Services Licence.
            </InnerSection>
            <InnerSection>
              <Span10>b)</Span10>
              <strong>The information provided on the Website or Services is general in nature and does not constitute financial advice. If any of the Content contains financial advice, it is general advice only and does not consider your personal circumstances.</strong>
            </InnerSection>
            <InnerSection>
              <Span10>c)</Span10>
              <strong>Livewire does not guarantee the accuracy of information on the Website or Services, including information provided by contributors or Third Parties.</strong>
            </InnerSection>
            <InnerSection>
              <Span10>d)</Span10>
              <strong>You will not rely on the Website or Services to make a financial or investment decision. Before making any decision, you must seek professional advice to take into account your particular investment objectives, financial situation and needs.</strong>
            </InnerSection>
            <InnerSection>
              <Span10>e)</Span10>
              <strong>You accept sole responsibility for using the information and material on the Website and Services; and the Website and Services is no substitute for financial advice.</strong>
            </InnerSection>
          </div>
        </span>
      </Section>
      <Headline>5. Conduct and Obligations</Headline>
      <Section>
        <Span10>5.1</Span10>
        <span>By accepting these Terms, you are representing that you:
          <div>
            <InnerSection>
              <Span10>a)</Span10>
              have the capacity to accept these Terms;
            </InnerSection>
            <InnerSection>
              <Span10>b)</Span10>
              will maintain the security and confidentiality of your User account, login details, password and identification; and
            </InnerSection>
            <InnerSection>
              <Span10>c)</Span10>
              will provide, or have provided, and will maintain and promptly update the Membership Data and ensure that information provided is accurate, current and complete.
            </InnerSection>
          </div>
        </span>
      </Section>
      <Section>
        <Span10>5.2</Span10>
        <span>You are solely responsible for the Content and all activities that occur under your Membership.</span>
      </Section>
      <Section>
        <Span10>5.3</Span10>
        <span>You agree not to upload, post, or otherwise transmit Content that:
          <div>
            <InnerSection>
              <Span10>a)</Span10>
              is inaccurate, misleading, incorrect, harmful, obscene, pornographic, defamatory, racist, sexist, threatening, violent, offensive, abusive, vulgar, profane, indecent, unlawful, harassing, or otherwise objectionable to Livewire or other Users of the Website,
              &nbsp;including any Content which is likely to offend, insult or humiliate others based on race, religion, ethnicity, gender, age, sexual orientation and/or any physical or mental disability;
            </InnerSection>
            <InnerSection>
              <Span10>b)</Span10>
              exploits another person in any manner;
            </InnerSection>
            <InnerSection>
              <Span10>c)</Span10>
              includes unauthorised disclosure of personal information;
            </InnerSection>
            <InnerSection>
              <Span10>d)</Span10>
              advertises services for non-individuals or for any other reason which is not aligned to the purposes for which the Services are intended;
            </InnerSection>
            <InnerSection>
              <Span10>e)</Span10>
              violates or infringes anyone&apos;s intellectual property rights; or
            </InnerSection>
            <InnerSection>
              <Span10>f)</Span10>
              contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment.
            </InnerSection>
          </div>
        </span>
      </Section>
      <Section>
        <Span10>5.4</Span10>
        <span>You must immediately notify Livewire of any unauthorised use of your User account, login and/or password.</span>
      </Section>
      <Section>
        <Span10>5.5</Span10>
        <span>You must ensure you completely sign out of your account at the end of every session where you use the Website, and ensure that all personal data has been deleted from the system.</span>
      </Section>
      <Section>
        <Span10>5.6</Span10>
        <span>Livewire may, but is not obliged to, at any time request a form of identification to verify your identity and/or your compliance with these Terms.</span>
      </Section>
      <Section>
        <Span10>5.7</Span10>
        <span>Livewire reserves the right to edit or remove Content that violates these Terms or for any other reason it deems necessary in its absolute discretion but shall not be held liable for its failure to do so.</span>
      </Section>
      <Section>
        <Span10>5.8</Span10>
        <span>Livewire may record and store information relating to your Membership, including any complaint made against you. Livewire reserves the right to disclose any information as necessary to satisfy any applicable law,
        &nbsp;legal requirement, police investigation or request from a Government authority.
        </span>
      </Section>
      <Section>
        <Span10>5.9</Span10>
        <span>Livewire reserves the right, but has no obligation, to monitor disputes between Users of the Website. You agree to hold Livewire harmless in connection with any dispute or claim that you make against any other User of the Website.</span>
      </Section>
      <Headline>6. Disclaimer of Warranties</Headline>
      <SubHeadline>You acknowledge that Livewire makes no representation or warranty:</SubHeadline>
      <Section>
        <Span10>6.1</Span10>
        <span>
          that your access to the Website or Services (including any Third Party applications or payment platforms on the Website) will be, timely, secure, uninterrupted and/or error-free;
        </span>
      </Section>
      <Section>
        <Span10>6.2</Span10>
        <span>that any defects on the Website will be corrected;</span>
      </Section>
      <Section>
        <Span10>6.3</Span10>
        <span>that any information disclosed on the Website or Services will be accurate, up to date, complete or useful;</span>
      </Section>
      <Section>
        <Span10>6.4</Span10>
        <span>that the Website or the server/s which stores and transmits the Website to you are free from viruses or any other harmful components;</span>
      </Section>
      <Section>
        <Span10>6.5</Span10>
        <span>about the accuracy, reliability or completeness of information on the Website or Services.</span>
      </Section>
      <Headline>7. Confidential Information</Headline>
      <Section>
        <Span10>7.1</Span10>
        <span>You agree to keep the Confidential Information of Livewire and any other User confidential and to use or disclose such information only for the purposes as authorised by the owner of the Confidential Information.</span>
      </Section>
      <Section><Span10>7.2</Span10>
        <span>The obligations of confidentiality in clause 7.1 will not apply to information which:
          <div>
            <InnerSection>
              <Span10>a)</Span10>
              is generally available in the public domain except where such availability is as a result of a breach of these Terms;
            </InnerSection>
            <InnerSection>
              <Span10>b)</Span10>
              was known by you before the disclosure of the information; or
            </InnerSection>
            <InnerSection>
              <Span10>c)</Span10>
              is required to be disclosed by a law or a court order.
            </InnerSection>
          </div>
        </span>
      </Section>
      <Headline>8. Intellectual Property Rights</Headline>
      <Section>
        <Span10>8.1</Span10>
        <span>Nothing in these Terms constitutes a transfer of any Intellectual Property rights. You acknowledge and agree that, as between you and Livewire, Livewire owns all Intellectual Property rights in the Website.</span>
      </Section>
      <Section>
        <Span10>8.2</Span10>
        <span>By using the Services, posting or adding any content onto the Website, you grant Livewire a perpetual, non-exclusive, royalty-free, irrevocable, worldwide and transferable right and licence to use that Content
        &nbsp;in any way (including, without limitation, reproducing, changing, and communicating the Content to the public) and permit Livewire to authorise any other User to do the same thing if Livewire chooses to do this.
        </span>
      </Section>
      <Section>
        <Span10>8.3</Span10>
        <span>You represent and warrant to Livewire that you have all necessary rights to grant the licences and consents set out in clause 8.2.</span>
      </Section>
      <Section>
        <Span10>8.4</Span10>
        <span>You must obtain express written permission from Livewire if you wish to reproduce any aspect of the Website or other Intellectual Property owned by Livewire.</span>
      </Section>
      <Headline>9. Termination and Suspension</Headline>
      <Section>
        <Span10>9.1</Span10>
        <span>The Terms will continue in force until such time that they are varied or replaced, but Livewire may terminate the Terms or the Website at any time and without prior Notice.</span>
      </Section>
      <Section>
        <Span10>9.2</Span10>
        <span>Livewire may suspend or terminate any User from using the Website without Notice.</span>
      </Section>
      <Section>
        <Span10>9.3</Span10>
        <span>Livewire reserves the right to change or discontinue any service or feature on the Website in whole or in part at any time in its sole discretion.</span>
      </Section>
      <Section>
        <Span10>9.4</Span10>
        <span>Livewire reserves the right to change pricing for any chargeable service or feature on the Website at any time, and will provide Notice in accordance with these Terms where the price is varied.</span>
      </Section>
      <Headline>10. Indemnity and Limitation of Liability</Headline>
      <Section>
        <Span10>10.1</Span10>
        <span>
          <strong>You agree to indemnify, and continually indemnify, Livewire in relation to all claims, actions, liabilities, costs, losses and expenses (including legal costs on a full indemnity basis)
          &nbsp;that Livewire incurs as a result of your use of the Website or Services, and/or from your failure to comply with these Terms.
          </strong>
        </span>
      </Section>
      <Section>
        <Span10>10.2</Span10>
        <span>
          <strong>You agree that Livewire shall not be liable to you in respect of any losses suffered or incurred by you arising out of or in connection with the provision of the Services,
          &nbsp;including but not limited to, reliance on the information or content on the Website.
          </strong>
        </span>
      </Section>
      <Section>
        <Span10>10.3</Span10>
        <span>Without limitation to the foregoing, you agree that, to the fullest extent permitted by law:
          <div>
            <InnerSection>
              <Span10>a)</Span10>
              Livewire’s maximum liability to you (if any) arising out of any kind of legal claim or action in any way connected to the Services or the Website (including negligence and under statute) will
              &nbsp;be limited to the total amount paid by you (if any) for any chargeable service provided by Livewire in the one month prior to the date of your claim.
            </InnerSection>
            <InnerSection>
              <Span10>b)</Span10>
              In no circumstances will Livewire be liable for any incidental, consequential or indirect damages, personal injury, death, damage to property, loss of property, loss or corruption of data,
              &nbsp;loss of profits, goodwill, bargain or opportunity, loss of anticipated savings or any other similar or analogous loss resulting from your access to, or use of (or inability to use) the Website or Services whether based on warranty,
              &nbsp;contract, tort, negligence, in equity or any other legal theory, and whether or not we knew or should have known of the possibility of such damage or loss.
            </InnerSection>
          </div>
        </span>
      </Section>
      <Section>
        <Span10>10.4</Span10>
        <span>
          Certain rights and remedies may be available under the Competition and Consumer Act 2010 (Cth) and may not be permitted to be excluded, restricted or modified. Apart from those that cannot be excluded,
          Livewire excludes all conditions and warranties that may be implied by law. To the extent permitted by law, Livewire’s liability for breach of any implied warranty or condition that cannot be excluded is restricted, at our option to:
          (a) the re-supply of services or payment of the cost of re-supply of services; or (b) the replacement or repair of goods or payment of the cost of replacement or repair.
        </span>
      </Section>
      <Headline>11. Advertisements and Promotion</Headline>
      <Section>
        <Span10>11.1</Span10>
        <span>Livewire may run sponsored advertisements and promotions from a Third Party on the Website or Services. Your correspondence or business dealings with, or participation in promotions of,
        &nbsp;advertisers other than Livewire found on or through the Website or Services, including payment and delivery of related goods or services, and any other terms, conditions, warranties or representations associated with such dealings,
        &nbsp;are solely between you and such Third Party. Livewire is not responsible or liable for any loss or damage of any sort incurred as the result of any such dealings or as the result of the presence of Third Party advertisers on the Website.
        </span>
      </Section>
      <Headline>12. General</Headline>
      <Section>
        <Span10>12.1</Span10>
        <span>These terms prevail in the event that anything in, or associated with, the Website or Services is inconsistent with these Terms.</span>
      </Section>
      <Section>
        <Span10>12.2</Span10>
        <span>If a provision of these Terms is invalid or unenforceable it is to be read down or severed to the extent necessary without affecting the validity or enforceability of the remaining provisions.</span>
      </Section>
      <Section>
        <Span10>12.3</Span10>
        <span>Any reference in these Terms to including, such as or similar expressions are to be interpreted as including, without limitation.</span>
      </Section>
      <Section>
        <Span10>12.4</Span10>
        <span>The failure by Livewire to enforce any provision of these Terms shall not be treated as a waiver of that provision, nor shall it affect Livewire’s right to subsequently enforce that provision.</span>
      </Section>
      <Section>
        <Span10>12.5</Span10>
        <span>These Terms and any contract to which they apply shall be governed by the laws of New South Wales and are subject to the jurisdiction of the courts of New South Wales.</span>
      </Section>
    </Container>
  );
}
